<template>
  <div class="d-flex">
    <div class="d-left" :class="{'d-left-hide':is_open_tree}">
      <erp-tree-status v-if="activeName === 'project'" @node-click="nodeClickProject" />
    </div>
    <div class="d-right" :class="{'d-right-ext':is_open_tree}">
      <div class="d-right-exttag" @click="isOpenTree">
        <i class="el-icon-d-arrow-left" v-if="!is_open_tree"></i>
        <i class="el-icon-d-arrow-right" v-if="is_open_tree"></i>
      </div>
      <transition name="slide-fade" mode="out-in">
        <keep-alive>
          <component :is="componentId"/>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerHouseLogMain from "@/components/Admin/Customer/components/customer-log/CustomerHouseLogMain";
import HrDepartmentTree from "../Common/hr-department-tree";
import ErpTreeStatus from "../Common/erp-tree-status";
export default {
  name: "CustomerHouseLog",
  components: {
    ErpTreeStatus,
    HrDepartmentTree,
    CustomerHouseLogMain,
  },
  provide(){
    return{
      mainObj:this.mainObj,
      componentId:this.componentId,
      setComponentId:this.setComponentId,
    }
  },
  data(){
    return{
      mainObj:{
        user_name:"",
        department_id:"",
        department_name:"",
        project_id:"",
        project_name:"",
        house_id:"",
        house_name:"",
        customer_id:"",
        customer_name:"",
      },
      activeName: "project",
      componentId:"CustomerHouseLogMain",
      is_open_tree:false,
    }
  },
  methods:{
    nodeClickDepartment(data) {
      const that=this;
      this.mainObj.department_id=data.id;
      this.mainObj.department_name=data.department_name;
    },
    nodeClickProject(data) {
      const that=this;
      that.mainObj.house_name = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      that.mainObj.project_id = data.tree[0].pindex_id;
      if (data.tree[data.tree.length - 1].type === "room") {
        that.mainObj.house_id = data.tree[data.tree.length - 1].id;
      } else {
        that.mainObj.house_id = 0;
      }
      data.customerName&&(that.mainObj.customer_name = data.customerName);
    },
    setComponentId(componentId){
      this.componentId=componentId;
    },
    isOpenTree(){
      this.is_open_tree = !this.is_open_tree;
    }
  },
}
</script>

<style lang="scss" scoped>
.d-flex {
  display: flex;
  flex-direction: row;
  margin: 10px;

  .d-left {
    border-right: 1px solid #eee;
    width: 250px;
    transition: all 0.3s ease;

    &.d-left-hide{
      width: 0;
      overflow: hidden;
    }
  }
  .d-right {
    margin-left: 10px;
    width: calc(100% - 260px);
    position: relative;
    transition: all 0.3s ease;
    &.d-right-ext{
      width: calc( 100% - 10px );
    }
    .d-right-exttag{
      position: absolute;
      top: 50%;
      left: 0;
      width: 30px;
      height: 30px;
      background-color: rgba(0,0,0,0.5);
      z-index: 99999;
      cursor: pointer;
      transform: translate(0,-50%);
      transition: all 0.3s ease;
      text-align: center;
      line-height: 30px;
      &:hover{
        background-color: rgba(0,0,0,0.8);
        box-shadow: 0 0 10px rgba(0,0,0,0.5);
      }
      i{
        color: #fff;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/CustomerHouseLog.vue